import React, { useRef } from 'react';
import { Button, Flex } from '@chakra-ui/react';

import { useTranslations } from '../../../../contexts/LocalizationContext';

type UnknownItemsConfirmFooterProps = {
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
  children?: React.ReactNode;
};

export const AssignItemsConfirmFooter = ({
  onConfirm,
  onCancel,
  isLoading,
  children,
}: UnknownItemsConfirmFooterProps) => {
  const cancelRef = useRef(null);
  const translations = useTranslations();

  return (
    <Flex pb={2}>
      <Button
        minW="120px"
        variant="orangeSolid"
        color="black"
        margin="auto"
        onClick={onConfirm}
        isLoading={isLoading}
        mr={3}
      >
        {children ?? translations('assign_items_confirmed')}
      </Button>
      <Button minW="120px" variant="transparent" color={'orange.500'} margin="auto" ref={cancelRef} onClick={onCancel}>
        {translations('cancel')}
      </Button>
    </Flex>
  );
};
